import { Show, createSignal } from "solid-js";

import { Logo } from "~/components/Logo";
import { ThemeToggle } from "~/components/ThemeToggle";
import { startLogin } from "~/lib/auth";

export function LoginPage() {
  const [error, setError] = createSignal<string | null>(null);
  const [busy, setBusy] = createSignal(false);

  const handleLogin = async (e: Event) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await startLogin("/workspaces");
      // On success, startLogin navigates the browser to ScaiKey; control
      // doesn't return here.
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  };

  return (
    <div class="min-h-screen flex items-center justify-center bg-base-200 relative">
      <div class="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div class="card w-96 bg-base-100 shadow-xl">
        <div class="card-body items-center text-center gap-4">
          <Logo width={200} height={48} class="mx-auto" />
          <p class="text-sm opacity-70">Sign in with ScaiKey to continue.</p>
          <button class="btn btn-primary w-full" disabled={busy()} onClick={handleLogin}>
            {busy() ? "Connecting…" : "Sign in with ScaiKey"}
          </button>
          <Show when={error()}>
            <div role="alert" class="alert alert-error text-sm text-left w-full">
              <div>
                <div class="font-semibold mb-1">Sign-in unavailable</div>
                <div class="opacity-80 break-all">{error()}</div>
              </div>
            </div>
          </Show>
        </div>
      </div>
    </div>
  );
}
